import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=384de09e&scoped=true"
import script from "./standard.vue?vue&type=script&lang=js"
export * from "./standard.vue?vue&type=script&lang=js"
import style0 from "./standard.vue?vue&type=style&index=0&id=384de09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384de09e",
  null
  
)

export default component.exports